module.exports = __webpack_public_path__ + "img/bicing-75.bd6f7f02.svg";